package diana.soleil.design.iraniancanadienbazzar.core.designsystem.component

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.selection.toggleable
import androidx.compose.material3.Switch
import androidx.compose.material3.SwitchDefaults
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.semantics.Role
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.theme.AppTheme

/**
 * Settings row with a trailing on/off switch (icon tile, title + optional subtitle). Mirrors
 * [SettingsRow] but for a boolean preference rather than a navigation action. The whole row toggles.
 */
@Composable
fun SettingsToggleRow(
    iconName: String,
    title: String,
    checked: Boolean,
    onCheckedChange: (Boolean) -> Unit,
    modifier: Modifier = Modifier,
    subtitle: String? = null,
) {
    Row(
        // toggleable on the row (not just the 32dp Switch) delivers the promised whole-row target
        // and merges title/subtitle into one labeled Switch node for screen readers — the Switch
        // itself gets onCheckedChange = null so it doesn't double up as a second unlabeled control.
        modifier = modifier
            .fillMaxWidth()
            .toggleable(
                value = checked,
                role = Role.Switch,
                onValueChange = onCheckedChange,
            )
            .padding(AppTheme.spacing.md),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.md),
    ) {
        Box(
            modifier = Modifier
                .size(AppTheme.sizes.avatarMd)
                .background(AppTheme.colors.surfaceContainer, AppTheme.shapes.md),
            contentAlignment = Alignment.Center,
        ) {
            AppIcon(name = iconName, size = AppTheme.sizes.iconMd, tint = AppTheme.colors.primary)
        }
        Column(modifier = Modifier.weight(1f)) {
            Text(text = title, style = AppTheme.typography.bodyLg, color = AppTheme.colors.onSurface)
            if (subtitle != null) {
                Text(
                    text = subtitle,
                    style = AppTheme.typography.bodySm,
                    color = AppTheme.colors.onSurfaceVariant,
                )
            }
        }
        Switch(
            checked = checked,
            onCheckedChange = null,
            colors = SwitchDefaults.colors(
                checkedThumbColor = AppTheme.colors.onPrimary,
                checkedTrackColor = AppTheme.colors.primary,
                uncheckedThumbColor = AppTheme.colors.outline,
                uncheckedTrackColor = AppTheme.colors.surfaceContainer,
                uncheckedBorderColor = AppTheme.colors.outline,
            ),
        )
    }
}
